import { render, staticRenderFns } from "./collectionTimeoutList.vue?vue&type=template&id=0cb655ae"
import script from "./collectionTimeoutList.vue?vue&type=script&lang=js"
export * from "./collectionTimeoutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports